import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { ScrollspyDirective } from "./scrollspy.directive";
import { LandingScrollspyDirective } from "./landingscrollspy.directive";
import { BreadcrumbsComponent } from "./components/breadcrumbs/breadcrumbs.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { CustomPipeModule } from "../core/pipe/custom.pipe";
import { ButtonPrimaryComponent } from "./components/button-submit/button-submit.component";
import { CommentListComponent } from "./components/comment/comment.component";
import { SimplebarAngularModule } from "simplebar-angular";
import { MessageComponent } from "./components/message/message.component";
import { PriorityComponent } from "./components/priority/priority.component";
import { TypeaheadComponent } from "./components/typeahead/typeahead.component";
import { DetailDemandeComponent } from "./components/detail-demande/detail-demande.component";
import { SelectComponent } from "./components/select/select.component";
import { SelectApiComponent } from "./components/select-api/select-api.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { TabsComponent } from "./components/tabs/tabs.component";
import { CardDmdComponent } from "./components/card-dmd/card-dmd.component";
import { RouterLink } from "@angular/router";
import { LoadingComponent } from "./components/loading/loading.component";
import { ButtonDownloadComponent } from "./components/button-download/button-download.component";
import { CardBonSortieComponent } from "./components/card-bon-sortie/card-bon-sortie.component";
import { ButtonBackComponent } from "./components/button-back/button-back.component";
import { ProfileAvatarComponent } from "./components/profile-avatar/profile-avatar.component";
import { CardConsultaionComponent } from "./components/card-consultation/card-dmd.component";
import { CardReceptionComponent } from "./components/card-reception/card-reception.component";
import { CardBonCommandeComponent } from "./components/card-bon-commande/card-bon-commande.component";
import { DistributionArticleDialogComponent } from "./dialog/distribution-article-dialog";
import { TruncateDecimalPipe } from "../core/pipe/truncate-decimal.pipe";
import { RestALivreCmnComponent } from "./common/rest-a-livrer/rest-a-livre.component";
import { MatDialogModule } from "@angular/material/dialog";
import { trafficLightComponent } from "./components/trafficLight/trafficLight.component";
import { ProgressComponent } from "./components/progress/progress.component";
import { DirectivesModule } from "../core/directive/directives.module";
import { FilterColorComponent } from "./components/filter-color/filter-color.component";
import { DateInputComponent } from "./components/input/input-date/input-date.component";
import { FlatpickrModule } from "angularx-flatpickr";
import { IconButtonComponent } from "./components/icon-button/icon-button.component";
import { CardComponent } from "./components/card/card.component";
import { PageHeaderComponent } from "./components/page-header/page-header.component";
import { InputComponent } from "./components/input-text/input-text.component";
import { CheckboxComponent } from "./components/input-checkbox/checkbox.component";
import { RadiobuttonComponent } from "./components/input-radiobutton/input-radiobutton.component";
import { TableComponent } from "./components/table/table.component";
import { TableFilterComponent } from "./components/table-filter/table-filter.component";
import { DynamicFilterComponent } from "./components/dynamic-table-filter/dynamic-filter.component";
import { RequiredComponent } from "./components/required/required.component";
import { DocumentHistoriqueComponent } from "./components/document-historique/document-historique.component";
import { DocumentVerrouBandeauComponent } from "./components/document-verrou-bandeau/document-verrou-bandeau.component";
import { PwaInstallPromptComponent } from "./components/pwa-install-prompt/pwa-install-prompt.component";
import { PushNotificationsComponent } from "./components/push-notifications/push-notifications.component";

@NgModule({
	declarations: [
		BreadcrumbsComponent,
		ScrollspyDirective,
		LandingScrollspyDirective,
		ButtonPrimaryComponent,
		CommentListComponent,
		MessageComponent,
		PriorityComponent,
		TypeaheadComponent,
		DetailDemandeComponent,
		SelectComponent,
		SelectApiComponent,
		TabsComponent,
		CardDmdComponent,
		LoadingComponent,
		ButtonDownloadComponent,
		CardBonSortieComponent,
		ButtonBackComponent,
		ProfileAvatarComponent,
		CardConsultaionComponent,
		CardReceptionComponent,
		CardBonCommandeComponent,
		DistributionArticleDialogComponent,
		//	TruncateDecimalPipe,
		RestALivreCmnComponent,
		trafficLightComponent,
		ProgressComponent,
		FilterColorComponent,
		DateInputComponent,
		IconButtonComponent,
		CardComponent,
		PageHeaderComponent,
		InputComponent,
		CheckboxComponent,
		RadiobuttonComponent,
		TableComponent,
		TableFilterComponent,
		DynamicFilterComponent,
		RequiredComponent,
		DocumentHistoriqueComponent,
		DocumentVerrouBandeauComponent,
		PwaInstallPromptComponent,
		PushNotificationsComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		CustomPipeModule,
		NgbPaginationModule,
		NgbDropdownModule,
		SimplebarAngularModule,
		NgbTypeaheadModule,
		NgSelectModule,
		NgbNavModule,
		RouterLink,
		MatDialogModule,
		ReactiveFormsModule,
		FlatpickrModule.forRoot(),
		DirectivesModule,
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		ScrollspyDirective,
		LandingScrollspyDirective,
		BreadcrumbsComponent,
		NgbPaginationModule,
		ButtonPrimaryComponent,
		CommentListComponent,
		MessageComponent,
		PriorityComponent,
		TypeaheadComponent,
		DetailDemandeComponent,
		SelectComponent,
		SelectApiComponent,
		TabsComponent,
		CardDmdComponent,
		LoadingComponent,
		ButtonDownloadComponent,
		CardBonSortieComponent,
		ButtonBackComponent,
		ProfileAvatarComponent,
		CardConsultaionComponent,
		CardReceptionComponent,
		CardBonCommandeComponent,
		DistributionArticleDialogComponent,
		//TruncateDecimalPipe,
		RestALivreCmnComponent,
		trafficLightComponent,
		ProgressComponent,
		DirectivesModule,
		FilterColorComponent,
		DateInputComponent,
		IconButtonComponent,
		CardComponent,
		PageHeaderComponent,
		InputComponent,
		CheckboxComponent,
		RadiobuttonComponent,
		TableComponent,
		TableFilterComponent,
		DynamicFilterComponent,
		RequiredComponent,
		DocumentHistoriqueComponent,
		DocumentVerrouBandeauComponent,
		PwaInstallPromptComponent,
		PushNotificationsComponent,
	],
	providers: [DatePipe],
})
export class SharedModule {}
